export default (context, inject) => {
    inject("alert", function (options) {
        return context.store.dispatch("alert/createAlert", options);
    });
};
